export const environment: Environment = {
  production: true,
  local: false,
  apiBaseUrl: window.ENV.APP_API_BASE_URL,
  apiAltUrl: window.ENV.APP_API_ALT_URL,
  options: window.ENV.APP_OPTIONS,
  sentryDsn: window.ENV.APP_SENTRY_DSN,
  tracesSampleRate: window.ENV.APP_TRACES_SAMPLE_RATE,
  //
  apiRouterUrl: window.ENV.APP_API_ROUTER_URL,
  baseLocation: window.ENV.APP_BASE_LOCATION,
  churchLocation: window.ENV.APP_CHURCH_LOCATION,
};
